export default __webpack_public_path__ + "static/media/finish.d594c425.png";